import { useQueryClient } from "@tanstack/react-query";
import { lazy, Suspense, useEffect } from "react";
import { Banner } from "./compontents/Banner";
import { useApp } from "./hooks/useApp";
import LoadingLayout from "./layouts/Loading";

const AudiencePicker = lazy(() => import("./layouts/AudiencePicker"));
const SearchLayout = lazy(() => import("./layouts/Search"));

function App() {
	const queryClient = useQueryClient();
	const { audience } = useApp();

	useEffect(() => {
		const onPopState = () => {
			queryClient.invalidateQueries({
				queryKey: ["filters"],
				exact: false,
			});
		};

		window.addEventListener("popstate", onPopState);
		return () => window.removeEventListener("popstate", onPopState);
	}, [queryClient]);

	return (
		<>
			<Suspense fallback={<LoadingLayout />}>
				{audience ? <SearchLayout /> : <AudiencePicker />}
			</Suspense>
			<Banner />
		</>
	);
}

export default App;
